import { get, isNull } from 'lodash'
import EventBus from '../../../utils/event-bus'

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    interval() {
      return this.$get('columnFilter')(this.name, {})
    },
    name() {
      return this.field.data
    },
    id() {
      return this.$get('id')
    },
    panelId() {
      return this.$get('panelId')
    },
    type() {
      return this.field.type
    },
  },
  methods: {
    assignInterval(value, prop) {
      let filter = Object.assign({}, this.interval)
      if (isNull(value) || value === '') {
        delete filter[prop]
      } else {
        Object.assign(filter, { [prop]: this.$moment.utc(value).format() })
      }
      return filter
    },
    onChange(value, prop) {
      const filter = this.assignInterval(value, prop)
      this.$dispatch('setFilter', { data: this.name, filter })
      EventBus.$emit(`apply-filter-${this.id}`, { id: this.id })
    },
  },
  watch: {
    interval: {
      immediate: true,
      handler() {
        this.from = get(this.interval, 'from', '')
        this.to = get(this.interval, 'to', '')
      },
    },
  },
}
